import AxiosClient from "../../../services/axios.services";

class PreparationServices {
  getPreparation = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_preparacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getPreparationById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_preparacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  savePreparation = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_preparacion/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editPreparation = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_preparacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deletePreparation = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_preparacion/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });
}

export default new PreparationServices();
